import React from "react"
import { ListGroup } from "react-bootstrap"
import { ReportAPI } from "../../lib/utils"
import ReportLinkItem from "./ReportLinkItem"

export default function LoanReportLinks({ api }) {

  return (
    <ListGroup>

      <ReportLinkItem url='/reports/active-loans' title='Active loans (Summary, Details)'
        disabled={ api === ReportAPI.ACTIVE_LOAN } />

      <ReportLinkItem url='/reports/expected-payment-by-date' title='Expected Payments By Date'
        disabled={ api === ReportAPI.EXPECTED_PAYMENT } />

      <ReportLinkItem url='/reports/balance-outstanding' title='Balance Outstanding'
        disabled={ api === ReportAPI.BALANCE_OUTSTANDING } />

      <ReportLinkItem url='/reports/aging-detail' title='Aging Detail'
        disabled={ api === ReportAPI.AGING_LOAN } />

      <ReportLinkItem url='/reports/portfolio-at-risk' title='Portfolio At Risk'
        disabled={ api === ReportAPI.PORTFOLIO_AT_RISK } />

      <ReportLinkItem url='/reports/branch-cash-in' title='Branch Cash In (Summary, Details)'
        disabled={ api === ReportAPI.BRANCH_CASH_IN } />

      <ReportLinkItem url='/reports/loan-generality' title='Loan Generality'
        disabled={ api === ReportAPI.LOAN_GENERALITY } />

      <ReportLinkItem url='/reports/loans-disbursed-by-affiliation' title='Loans Disbursed By Affiliation'
        disabled={ api === ReportAPI.LOAN_DISBURSED } />

      <ReportLinkItem url='/reports/defaulted-loans' title='Defaulted Loans'
        disabled={ api === ReportAPI.DEFAULTED_LOAN_DETAILS } />
    </ListGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/Reports/LoanReportLinks.js